import { Section } from '@/components/layout';
import { Sparkle } from '@/components/ornaments';
import { Reveal } from '@/components/motion';
import { MANTRA } from '../hub.content';
import styles from './HubMantra.module.css';

/**
 * El mantra de la marca, solo en su banda. No es un heading: es una declaracion,
 * asi que va en `<p>` y no ocupa un nivel de la jerarquia de titulos.
 */
export function HubMantra() {
  return (
    <Section background="alt" spacing="tight" width="default">
      <Reveal>
        <div className={styles.mantra}>
          <p className={styles.text}>{MANTRA}</p>
          <Sparkle size={18} />
        </div>
      </Reveal>
    </Section>
  );
}
